import { useQuery } from "@tanstack/react-query";
import { fetchConfigFiles } from "../apis/channel";
import { FIXED_CHANNEL_KEYS, QUERY_KEYS } from "../constants";

const useConfigureFiles = (location?: string) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [QUERY_KEYS.CONFIGS, location],
    queryFn: () => fetchConfigFiles(location),
  });

  return {
    data,
    isLoading,
    refetch,
    screenSaver: data?.communityConfiguration?.channels?.find(
      (c) => c.title === FIXED_CHANNEL_KEYS.SCREEN_SAVER
    ),
    myPlace: data?.communityConfiguration?.channels?.find(
      (c) => c.title === FIXED_CHANNEL_KEYS.MY_PLACE
    ),
  };
};

export default useConfigureFiles;
